import wxRequest from '@/utils/wx-request'

export function getUserInfo(data) {
  return wxRequest.post('/app_service/api/GetUser', data)
}



// WEBPACK FOOTER //
// ./src/api/user.js